// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3b7Yw","col":"styles_col__32_Ub","actions":"styles_actions__3LLsy","conflict":"styles_conflict__c7abS"};